import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { OylBitcoinInjectedProvider } from '../OylBitcoinInjectedProvider.types';

const OYL_BITCOIN_PROVIDER_LOCATOR = 'oyl';

export const getOylBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<OylBitcoinInjectedProvider>(
    OYL_BITCOIN_PROVIDER_LOCATOR
  );
};
